/**
 * WarehouseResource
 */

export enum WarehouseProcessingTypeEnum {
  Complex = "complex",
  Simple = "simple",
}

export enum DocProtocol {
  Ftp = "ftp",
  Ipp = "ipp",
}

export interface WarehousePrinterSettingsResource {
  id: string;
  gid: string;
  warehouse_id: string | null;
  protocol: DocProtocol;
  username: string;
  password: string;
  label_address: string;
  doc_address: string;
  doc_printer_name: string;
  label_printer_name: string;
  use_password: boolean;
}
export interface WarehouseResource {
  id: string;
  gid: string;
  number: string;
  title: string;
  is_for_sale: boolean;
  is_active: boolean;
  owner_id?: string;
  processing_type: WarehouseProcessingTypeEnum;
  processing_max_orders: number;
  processing_pre_commissioning: boolean;
  processing_packing: boolean;
  printer_settings?: WarehousePrinterSettingsResource | null;
  additional_warehouses?: WarehouseResource[];
}

/**
 * WarehouseOperationTypeEnum
 */
export type WarehouseOperationTypeEnum =
  | "InOperationBuying"
  | "InOperationInventory"
  | "InOperationReturn"
  | "InOperationAdjustment"
  | "OutOperationOrder"
  | "OutOperationInventory"
  | "OutOperationBestBeforeDate"
  | "OutOperationPromotion"
  | "OutOperationAdjustment"
  | "TransferOperation"
  | "TransferOperationOwner";

export type UpdateWarehouseRequest = {
  title?: string;
  is_for_sale?: boolean;
  is_active?: boolean;
  owner_id?: string;
};
export type StoreWarehouseRequest = {
  title: string;
  is_for_sale?: boolean;
  is_active?: boolean;
  owner_id?: string;
};
